<script>
    // core components
    import TransporteView from "../../viewsERP/Transporte.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <TransporteView />
    </div>
  </div>